import { createSlice } from "@reduxjs/toolkit";

export interface SideBarState {
  value: boolean;
}

const initialState: SideBarState = {
  value: false,
};

export const SideBarSlice = createSlice({
  name: "sidebar",
  initialState,
  reducers: {
    handleSidebar: (state) => {
      state.value = !state.value;
    },
  },
});

// Action creators are generated for each case reducer function
export const { handleSidebar } = SideBarSlice.actions;

export default SideBarSlice.reducer;
